'use client'

import { ArrowUp } from 'lucide-react'
import { useEffect, useState } from 'react'

export default function BackToTop() {
  const [visible, setVisible] = useState(false)
  const [reduced, setReduced] = useState(false)

  useEffect(() => {
    // Respecte prefers-reduced-motion
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)')
    const onChange = (e: MediaQueryListEvent) => setReduced(e.matches)
    setReduced(mq.matches)
    mq.addEventListener?.('change', onChange)

    const onScroll = () => setVisible(window.scrollY > 300)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      mq.removeEventListener?.('change', onChange)
      window.removeEventListener('scroll', onScroll)
    }
  }, [])

  const scrollToTop = () => {
    const behavior = reduced ? 'auto' : 'smooth'
    window.scrollTo({ top: 0, left: 0, behavior })
  }

  return (
    <div
      aria-hidden={!visible}
      className={[
        'fixed bottom-6 left-6 tablet:bottom-8 tablet:left-8 z-40',
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3 pointer-events-none',
        'transition-all duration-300 ease-out',
      ].join(' ')}
    >
      <button
        type="button"
        onClick={scrollToTop}
        aria-label="Remonter en haut de la page"
        className="group rounded-[3px] border border-ink/20 bg-paper p-3 text-ink shadow-sm transition-colors hover:border-ink hover:bg-ink hover:text-chalk"
      >
        <ArrowUp className="h-5 w-5 transition-transform duration-200 group-hover:-translate-y-0.5" />
        <span className="sr-only">Haut de page</span>
      </button>
    </div>
  )
}
